(function () {
    const state = {
        basket: {},
        delay: {},
        compare: {},
        loaded: false,
        loadPromise: null,
        readyCallbacks: [],
        updateListeners: [],

        init() {
            const iblockId = this.getCurrentIblockId();
            this.loadPromise = this.fetchBasketData(iblockId)
                .then((data) => {
                    this.basket = data.BASKET || {};
                    this.delay = data.DELAY || {};
                    this.compare = data.COMPARE || {};
                    this.loaded = true;
                    this._notifyReady();
                    this._notifyUpdate();
                })
                .catch(() => {
                    this.loaded = true;
                    this._notifyReady();
                });

            if (window.BX && typeof window.BX.addCustomEvent === 'function') {
                window.BX.addCustomEvent('onCompleteAction', (eventData) => {
                    if (eventData && eventData.action && String(eventData.action).indexOf('loadBasket') === 0) {
                        this.refresh();
                    }
                });
            }
        },

        refresh() {
            const iblockId = this.getCurrentIblockId();
            this.loadPromise = this.fetchBasketData(iblockId)
                .then((data) => {
                    this.basket = data.BASKET || {};
                    this.delay = data.DELAY || {};
                    this.compare = data.COMPARE || {};
                    this._notifyUpdate();
                })
                .catch(() => {
                    // ignore
                });
        },

        getCurrentIblockId() {
            const card = document.querySelector('#product-info-block');
            return card ? card.getAttribute('data-iblock-id') : 31;
        },

        fetchBasketData(iblockId) {
            return fetch(`/ajax/actualBasket.php?iblockID=${iblockId}`)
                .then((response) => response.text())
                .then((html) => {
                    const match = html.match(/var arBasketAspro = ({.*?});/s);
                    if (match && match[1]) {
                        return eval('(' + match[1] + ')');
                    }
                    return {};
                });
        },

        onReady(callback) {
            if (this.loaded) {
                callback();
            } else {
                this.readyCallbacks.push(callback);
            }
        },

        addUpdateListener(fn) {
            this.updateListeners.push(fn);
        },

        _notifyReady() {
            this.readyCallbacks.forEach((cb) => cb());
            this.readyCallbacks = [];
        },

        _notifyUpdate() {
            this.updateListeners.forEach((fn) => fn());
        },
    };

    window.CatalogCardState = state;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => state.init());
    } else {
        state.init();
    }
})();
